<template>
  <div class="main">
    <div class="about">
      <img class="bar_img" src="@/img/about.png" alt="" />
      <div class="about_title">{{ $t("contact.about.title") }}</div>
      <div class="about_content">
        <div class="about_content_text">
          {{ $t("contact.about.content") }}
        </div>
      </div>
    </div>
    <div class="careers">
      <div class="careers_header">
        <div class="careers_header_name">
          {{ $t("contact.careers.name") }}
        </div>
      </div>
      <div class="careers_box">
        <el-tabs
          class="careers_tabs"
          v-model="activeName"
          :stretch="true"
          @tab-click="handleClick"
        >
          <el-tab-pane :label="$t('contact.careers.title1')" name="title1">
            <div class="tab">
              <div class="tab_box">
                <div class="tab_box_title">
                  {{ $t("contact.careers.title1") }}
                </div>
                <div
                  class="tab_box_text"
                  v-for="(item, i) in $t('contact.careers.text1')"
                >
                  <div class="tab_box_text_active"></div>
                  <div class="tab_box_text_text">{{ item }}</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('contact.careers.title2')" name="title2">
            <div class="tab">
              <div class="tab_box">
                <div class="tab_box_title">
                  {{ $t("contact.careers.title2") }}
                </div>
                <div
                  class="tab_box_text"
                  v-for="(item, i) in $t('contact.careers.text2')"
                >
                  <div class="tab_box_text_active"></div>
                  <div class="tab_box_text_text">{{ item }}</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('contact.careers.title3')" name="title3">
            <div class="tab">
              <div class="tab_box">
                <div class="tab_box_title">
                  {{ $t("contact.careers.title3") }}
                </div>
                <div
                  class="tab_box_text"
                  v-for="(item, i) in $t('contact.careers.text3')"
                >
                  <div class="tab_box_text_active"></div>
                  <div class="tab_box_text_text">{{ item }}</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('contact.careers.title4')" name="title4">
            <div class="tab">
              <div class="tab_box">
                <div class="tab_box_title">
                  {{ $t("contact.careers.title4") }}
                </div>
                <div
                  class="tab_box_text"
                  v-for="(item, i) in $t('contact.careers.text4')"
                >
                  <div class="tab_box_text_active"></div>
                  <div class="tab_box_text_text">{{ item }}</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('contact.careers.title5')" name="title5">
            <div class="tab">
              <div class="tab_box">
                <div class="tab_box_title">
                  {{ $t("contact.careers.title5") }}
                </div>
                <div
                  class="tab_box_text"
                  v-for="(item, i) in $t('contact.careers.text5')"
                >
                  <div class="tab_box_text_active"></div>
                  <div class="tab_box_text_text">{{ item }}</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="contact">
      <img class="contact_img" src="@/img/contact.png" alt="" />
      <div class="contact_header">
        <div class="contact_header_name">
          {{ $t("contact.contact.name") }}
        </div>
      </div>
      <div class="contact_box">
        <div class="contact_box_info">
          <img class="contact_box_info_img" src="@/img/company.png" alt="" />
          <div class="contact_box_info_text">
            {{ $t("contact.contact.company") }}
          </div>
        </div>
        <div class="contact_box_info">
          <img class="contact_box_info_img" src="@/img/place.png" alt="" />
          <div class="contact_box_info_text">
            {{ $t("contact.contact.place") }}
          </div>
        </div>
        <div class="contact_box_info">
          <img class="contact_box_info_img" src="@/img/email.png" alt="" />
          <div class="contact_box_info_text">
            {{ $t("contact.contact.email") }}
          </div>
        </div>
        <img class="contact_joinUs" src="@/img/joinUs.png" alt="" />
      </div>
      <div class="contact_form">
        <el-row>
          <el-col span="9">
            <el-input
              v-model="first"
              :placeholder="$t('contact.contact.form.first')"
            ></el-input>
          </el-col>
          <el-col span="15">
            <div class="contact_form_last">
              <el-input
                v-model="last"
                :placeholder="$t('contact.contact.form.last')"
              >
              </el-input>
            </div>
          </el-col>
        </el-row>
        <el-input
          v-model="email"
          :placeholder="$t('contact.contact.form.email')"
        >
        </el-input>
        <el-input
          v-model="company"
          :placeholder="$t('contact.contact.form.company')"
        >
        </el-input>
        <el-input
          type="textarea"
          :rows="3"
          :placeholder="$t('contact.contact.form.remark')"
          v-model="remark"
        >
        </el-input>
        <div class="contact_form_button" @click="sendEmail">
          <div class="contact_form_button_text">
            {{ $t("contact.contact.form.submit") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { BASE_HOST } from "@/config/config";
export default {
  components: {},
  data() {
    return {
      activeName: "title1",
      first: "",
      last: "",
      email: "",
      company: "",
      remark: "",
    };
  },

  methods: {
    async sendEmail() {
      let pattern =
        /^\w+(?:\.\w+){0,1}@[a-zA-Z0-9]{2,14}(?:\.[a-z]{2,4}){1,2}$/;
      if (!pattern.test(this.email)) {
        this.$message.info(this.$t("contact.contact.emailInfo"));
        return;
      }
      if (this.first == "" || this.last == "") {
        this.$message.info(this.$t("contact.contact.info"));
        return;
      }
      await this.$axios
        // .post("http://192.168.1.34:3000/email/sendCode", {
        // .post("https://new-test.just4fun.sg/tools/email/sendCode", {
        .post(`${BASE_HOST}/tools/email/sendCode`, {
          to: "business_global@just4fun.sg",
          first: this.first,
          last: this.last,
          email: this.email,
          company: this.company,
          remark: this.remark,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success(this.$t("contact.contact.success"));
          } else {
            this.$message.error(this.$t("contact.contact.error"));
          }
        });
    },
  },
};
</script>

<style scoped="scoped">
.test {
  /* background-image: url("~@/img/background.png"); */
  height: 600px;
}
.about {
  display: flex;
  position: relative;
}
.bar_img {
  width: 100%;
  height: 514px;
  object-fit: cover;
}
.about_title {
  position: absolute;
  padding: 180px 0 0 359px;
  font-family: MicrosoftYaHei-Bold;
  font-size: 42px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 78px;
  letter-spacing: 0px;
  color: #2b3543;
}
.about_content {
  position: absolute;
  padding: 268px 0 0 359px;
}
.about_content_text {
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 26px;
  letter-spacing: 0px;
  color: #646a73;
  width: 538px;
}
.careers {
  width: 100%;
  height: 660px;
  background-color: #ffffff;
}
.careers_header {
  width: 100%;
  position: absolute;
}
.careers_header_name {
  padding-top: 92px;
  font-family: MicrosoftYaHei;
  font-size: 36px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 78px;
  letter-spacing: 0px;
  color: #2b3543;
  text-align: center;
}
.careers_box {
  width: 100%;
  position: absolute;
}
.careers_tabs {
  width: 1000px;
  padding-top: 200px;
  margin-left: 25%;
}
.tab {
  width: 1000px;
  height: 300px;
  background-color: #f7fafa;
  border-radius: 6px;
  overflow: auto;
}
.tab_box {
  padding: 38px 0 27px 70px;
}
.tab_box_title {
  font-family: MicrosoftYaHei-Bold;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 43px;
  letter-spacing: 0px;
  color: #333333;
}
.tab_box_text {
  display: flex;
  align-items: center;
}
.tab_box_text_active {
  width: 8px;
  height: 8px;
  background-color: #8a8ea1;
  border-radius: 50%;
  margin-right: 17px;
}
.tab_box_text_text {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 33px;
  color: #8a8ea1;
}
.contact {
  display: flex;
  position: relative;
}
.contact_img {
  width: 100%;
  height: 660px;
  object-fit: cover;
}
.contact_header {
  width: 100%;
  position: absolute;
}
.contact_header_name {
  padding-top: 92px;
  font-family: MicrosoftYaHei;
  font-size: 36px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 78px;
  letter-spacing: 0px;
  color: #2b3543;
  text-align: center;
}
.contact_box {
  margin: 201px 0 0 360px;
  position: absolute;
}
.contact_box_info {
  display: flex;
  align-items: center;
}
.contact_box_info_img {
  width: 30px;
  height: 30px;
  margin-right: 12px;
}
.contact_box_info_text {
  font-family: MicrosoftYaHei;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 48px;
  letter-spacing: 1px;
  color: #8a8ea1;
}
.contact_joinUs {
  margin-top: 50px;
}
.contact_form {
  margin: 201px 0 0 1220px;
  position: absolute;
  width: 400px;
}

.el-input {
  font-family: MicrosoftYaHei;
  font-weight: normal;
  font-stretch: normal;
  line-height: 50px;
  letter-spacing: 0px;
  color: #2b3543;
  margin-bottom: 15px;
  font-size: 16px;
}

.contact_form >>> .el-input__inner {
  width: 100%;
  height: 50px;
  border-radius: 10px;
  padding: 0 20px;
}
.contact_form >>> .el-textarea__inner {
  width: 100%;
  padding: 10px 20px;
  font-family: MicrosoftYaHei;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  color: #2b3543;
  border-radius: 10px;
}
.contact_form_button {
  width: 400px;
  height: 56px;
  background-color: #4990fa;
  border-radius: 10px;
  margin-top: 30px;
  cursor: pointer;
}
.contact_form_button_text {
  font-family: Arial-BoldMT;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 56px;
  letter-spacing: 0px;
  color: #ffffff;
  text-align: center;
}
.contact_form_button:hover {
  background-color: #66a8ff;
}
.contact_form_name {
  display: flex;
}
.contact_form_first {
  width: 155px;
}
.contact_form_last {
  padding-left: 15px;
}
</style>
<style>
.el-tabs__item {
  font-size: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/contact.vue